var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.contract.actions.block
        ? [
            _c(
              "b-btn",
              {
                staticClass:
                  "btn btn-card-action btn-card-action-danger text-uppercase my-1 inactive",
                attrs: { id: _vm.blockRequestId },
              },
              [_vm._v("Заблокировать")]
            ),
            _c(
              "b-popover",
              { attrs: { target: _vm.blockRequestId, triggers: "hover" } },
              [
                _c(
                  "span",
                  { staticClass: "fs-12" },
                  [
                    _vm._v("Запрос на блокировку на "),
                    _c(
                      "router-link",
                      {
                        staticClass: "atmo-button-link",
                        attrs: { to: { name: "CabinetFl44BlockRequests" } },
                      },
                      [_vm._v("рассмотрении")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        : [
            _c(
              "b-btn",
              {
                staticClass:
                  "btn btn-card-action btn-card-action-danger text-uppercase my-1",
                attrs: { id: _vm.blockRequestId },
                on: {
                  click: function ($event) {
                    _vm.showBlockRequestModal =
                      _vm.$store.getters.getCanSign && true
                  },
                },
              },
              [_vm._v("Заблокировать")]
            ),
            !_vm.$store.getters.getCanSign
              ? _c(
                  "b-popover",
                  { attrs: { target: _vm.blockRequestId, triggers: "hover" } },
                  [
                    _vm.$store.getters.getLoginType === "cert"
                      ? _c(
                          "span",
                          { staticClass: "fs-12" },
                          [
                            _vm._v(
                              "Для действия требуется загрузить/заменить МЧД на странице: "
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "atmo-button-link",
                                attrs: { to: { name: "CabinetUserProfile" } },
                              },
                              [_vm._v("Данные учетной записи")]
                            ),
                          ],
                          1
                        )
                      : _c("span", { staticClass: "fs-12" }, [
                          _vm._v(
                            "Для действия требуется авторизация при помощи ЭЦП"
                          ),
                        ]),
                  ]
                )
              : _vm._e(),
          ],
      _c(
        "b-modal",
        {
          attrs: {
            title: "Запрос блокировки внесистемной закупки",
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
          },
          on: { hide: _vm.onHide },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function () {
                return [_c("button-close-modal")]
              },
              proxy: true,
            },
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isLoading,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "custom-outline-secondary" },
                          on: { click: _vm.onHide },
                        },
                        [_vm._v("Отмена ")]
                      ),
                      _vm._v("  "),
                    ],
                    1
                  ),
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isLoading,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled: _vm.$v.$invalid,
                            variant: "custom-danger",
                          },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("Подтвердить")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showBlockRequestModal,
            callback: function ($$v) {
              _vm.showBlockRequestModal = $$v
            },
            expression: "showBlockRequestModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-block text-left" },
            [
              _c("p", [
                _vm._v(
                  "Вы уверены, что хотите отправить запрос на блокировку закупки №" +
                    _vm._s(_vm.contract.purchase_info.reg_number) +
                    "?"
                ),
              ]),
              _c("form-row-edit-textarea", {
                attrs: {
                  label: "Введите причину запроса блокировки",
                  v: _vm.$v.blockMessage,
                  rows: 4,
                  "label-on-top": "",
                },
                model: {
                  value: _vm.blockMessage,
                  callback: function ($$v) {
                    _vm.blockMessage = $$v
                  },
                  expression: "blockMessage",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }